export default {
  en: {
    TellerSMSLog: {
      title: 'Arrived SMS Log',
    },
  },
};
